import elplanStore from 'store/elplan/elplan'
import { translateKeyWithSpecificTranslations } from 'utils/stringUtils'
import { snapshot } from 'valtio'

export function getScenarioName(scenarioId: number, translations?: { [key: string]: string }): string {
  const elplanSnap = snapshot(elplanStore)
  const scenarioName = elplanSnap.scenarios.find((scenario) => scenario.id === scenarioId)?.scenario_name ?? ''
  return translateKeyWithSpecificTranslations(scenarioName, translations)
}
